import React from 'react';
import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import logo from '../../Assets/logo.png';

const WHATSAPP_NUMBER = '01288339973';

const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/nuvvy.eg?igsh=ZXVmamVmMm16bzZ6&utm_source=qr',
    icon: <InstagramIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/18W4KAzweD/?mibextid=wwXIfr',
    icon: <FacebookIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@nuvvy.eg?_r=1&_t=ZT-94M8uD0Z3qX',
    icon: <MusicNoteIcon sx={{ fontSize: 18 }} />,
  },
];

const PublicFooter = () => {
  const normalizedWhatsapp = WHATSAPP_NUMBER.replace(/\D/g, '');
  const whatsappHref = `https://wa.me/${normalizedWhatsapp}`;

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        borderTop: '1px solid #dde7f3',
        background: 'linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%)',
        py: { xs: 3, md: 4 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          spacing={2}
          sx={{ direction: 'rtl' }}
        >
          <Box sx={{ minWidth: { md: 250 } }}>
            <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 0.75 }}>
              <Box
                component="img"
                src={logo}
                alt="Nuvvy"
                sx={{ width: 42, height: 42, borderRadius: 1.5, objectFit: 'contain' }}
              />
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                Nuvvy
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              كافيه عصري بنكهات مميزة وتجربة ضيافة مختلفة.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            {socialLinks.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  fontWeight: 600,
                  px: 1.25,
                  py: 0.6,
                  borderRadius: 2,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d9e4f2',
                }}
              >
                {item.icon}
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box sx={{ minWidth: { md: 230 } }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                رقم واتساب
              </Typography>
              <Link
                href={whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                color="inherit"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  fontWeight: 700,
                  px: 1.25,
                  py: 0.75,
                  borderRadius: 2,
                  backgroundColor: '#ffffff',
                  border: '1px solid #bde7cd',
                }}
              >
                <WhatsAppIcon sx={{ color: '#25D366', fontSize: 20 }} />
                {WHATSAPP_NUMBER}
              </Link>
            </Box>

            <Box sx={{ minWidth: { md: 280 } }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                العنوان
              </Typography>
              <Link
                href="https://maps.app.goo.gl/caRoMPwFR249fFH96"
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                color="inherit"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'flex-start',
                  gap: 0.75,
                  fontWeight: 600,
                  px: 1.25,
                  py: 0.75,
                  borderRadius: 2,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d9e4f2',
                  transition: '0.2s ease',
                  '&:hover': {
                    borderColor: '#c5b8e6',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  },
                }}
              >
                <LocationOnIcon sx={{ color: '#d32f2f', fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', fontWeight: 700 }}>
                    البحيرة - كفر الدوار
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontSize: '11px', color: '#666' }}>
                    شارع الحدايق - أمام أبراج الحلواني
                  </Typography>
                </Box>
              </Link>
            </Box>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
          © {new Date().getFullYear()} BESOFT License for Nuvvy only - جميع الحقوق محفوظة
        </Typography>
      </Container>
    </Box>
  );
};

export default PublicFooter;
